function handle2faRequirement() {
  const $form = $('.login-form');

  if ($form.length > 0) {
    let otpRequired = true;

    $form.on('submit', (e) => {
      const data = $form.serialize();
      const $otpAttempt = $form.find('input[id$=otp_attempt]');

      if ($otpAttempt.val() === '' && otpRequired === true) {
        e.preventDefault();

        const twoFactorVerificationPath = $form.data('two-factor-path');

        $.post(twoFactorVerificationPath, data, (response) => {
          if (response.otp_required === true) {
            $form.find('.login-password-fields').hide();
            $form.find('.login-2fa-fields').removeClass('d-none');
          } else {
            otpRequired = false;

            $form.submit();
          }
        });

        return false;
      }

      return true;
    });
  }
}

$(document).ready(() => {
  handle2faRequirement();
});
